import { createApp } from "vue";
import { createPinia } from "pinia";
import persistedState from "pinia-plugin-persistedstate";
import { MotionPlugin } from "@vueuse/motion";
import router from "./router";
import App from "./App.vue";
import { App as CapApp } from "@capacitor/app";
import "./style.css";
import "@/assets/css/transitions.css";

const app = createApp(App);

const pinia = createPinia();
pinia.use(persistedState);

app.use(pinia);
app.use(router);
app.use(MotionPlugin);

app.mount("#app");

CapApp.addListener("backButton", ({ canGoBack }) => {
    canGoBack ? router.back() : App.exitApp();
});
